import * as React from 'react';

import { Facebook, LinkedIn, Twitter, YouTube } from '../../assets/icons';
import wwwApconCom from '../../www.apcon.com';

const content = {
  hero: {
    title: 'Get a quote',
    description: [
      <p key="1">
        Request a quote here to get pricing, offers, and product information
        over the phone or through email. Are you a channel partner? Get help
        with quotes and manage your deals through our{' '}
        <a href="https://portal.apcon.com/English/">partner portal</a>.
      </p>,
    ],
  },

  form: {
    hiddenTitle: 'Get a quote',
    description: "We're excited to answer your questions and send you a quote.",
    phone: '1-800-624-6808',
    email: 'info@apcon.com',
    colorTheme: 'cyan',
    socialMediaLinks: [
      {
        id: 1,
        name: 'YouTube',
        url: wwwApconCom.social.youtube,
        icon: <YouTube />,
      },
      {
        id: 2,
        name: 'LinkedIn',
        url: wwwApconCom.social.linkedin,
        icon: <LinkedIn />,
      },
      {
        id: 3,
        name: 'Facebook',
        url: wwwApconCom.social.facebook,
        icon: <Facebook />,
      },
      {
        id: 4,
        name: 'Twitter',
        url: wwwApconCom.social.twitter,
        icon: <Twitter />,
      },
    ],
  },

  offices: {
    title: 'Our offices',
    description:
      'With offices in Oregon and Texas, our engineering and manufacturing teams create products that regularly set new benchmarks in scalable network technology.',
    contactCards: [
      {
        id: 1,
        title: 'Oregon',
        address: '9255 SW Pioneer Ct, Wilsonville, OR 97070, USA',
        phone: '503-682-4050',
        fax: '503-682-4059',
        iframe: {
          url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22436.361938566646!2d-122.77778239999999!3d45.33780480000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54956ddb302ba69b%3A0x4e0a585e4962f553!2sAPCON%2C%20Inc.!5e0!3m2!1sen!2sus!4v1638554039871!5m2!1sen!2sus',
          title: 'Get directions to the Oregon office',
        },
      },
      {
        id: 2,
        title: 'Texas',
        address: '4351 Mapleshade Ln, Plano, TX 75093, USA',
        phone: '972-372-0198',
        fax: '972-808-7800',
        iframe: {
          url: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13383.556910673737!2d-96.7781349!3d33.0066958!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd6613d86ff0f9d1f!2sApcon!5e0!3m2!1sen!2sus!4v1638561167785!5m2!1sen!2sus',
          title: 'Get directions to the Texas office',
        },
      },
    ],
  },
};

export default content;
